import getTermsRow from "../DataDisplayRow/TermsRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class TermsRowTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getTermsRow()
    }
}

let termsTable: TermsRowTable | null = null;

export default function getTermsTable(): TermsRowTable {
    if (termsTable === null)
        termsTable = new TermsRowTable()
    return termsTable
}